class ApiRoutes {
  static baseUrl = "https://gigmvip.gigmobility2.com/api/v1/";
  static paystackBaseUrl = "https://api.paystack.co";
  static verifyAccountPayStack = "/bank/resolve";
  static register = "/account/register";
  static setBoatAvailability = "/Boat/setBoatAvailability";
  static changePassword = "/account/changePassword";
  static changePinOtp = "/Wallet/generateOtp";
  static walletTransfer = "Wallet/Transfer";
  static createBoat = "/Boat/createBoat";
  static createWallet = "/Wallet/createWallet";
  static viewBoatsByPartnerId = "/Boat/getBoatsByPartnerId?partnerId=";
  static getBanks = "/Wallet/getBanks";
  static getAdmins = "Partner/getStaffs/";
  static getWalletOtp = "Wallet/generateOtp";
  static getWallet = "/Wallet/getUserWallet";
  static getIncomeExpense = "/Wallet/getIncomeExpense";
  static getDashBoard = "/Dashboard/getBoatDashboard";
  static getTransaction = "Wallet/walletTransactionHistory";
  static verifyEmail = "/account/verifyEmailAddress";
  static forgotPassword = "/account/forgotPassword";
  static resetPassword = "/account/resetPassword";
  static getBookingDetails = "/Boat/getBoatBookingDetails";
  static getTripAvailability = "/TripRatings/tripAvailability";
  static getBoatHireHistory = "/Boat/getBoatHireHistory";
  static verifyPhoneNumber = "/account/verifyMobileNumber";
  static sendOtpEmail = "/account/sendEmailOtp";
  static uploadBoatImages = "/Boat/uploadBoatPictures";
  static editBoatImages = "/Boat/editBoatPictures";
  static sendOtpPhoneNumber = "/account/sendMobileOtp";
  static login = "/account/login";
  static disableAdmin = "/Partner/deleteStaff/";
  static createAdmin = "/SuperAdmin/createPartnerStaff";
  static boatPrice = "/Boat/setBoatPrice";
}

export default ApiRoutes;
